(function () {
  const sectionSelector = '.section-product-recommendations';

  function init(section) {
    if (!section || section.dataset.productRecommendationsCarouselInitialized === 'true') return;

    const slider = section.querySelector('[data-product-recommendations-slider]');
    const controls = section.querySelector('[data-product-recommendations-controls]');

    if (!slider || !controls || typeof Flickity === 'undefined') return;

    const rightToLeft = document.dir === 'rtl';
    const flickity = Flickity.data(slider) || new Flickity(slider, {
      wrapAround: false,
      cellAlign: rightToLeft ? 'right' : 'left',
      pageDots: false,
      contain: true,
      prevNextButtons: false,
      cellSelector: '.carousel__slide',
      rightToLeft
    });

    section.dataset.productRecommendationsCarouselInitialized = 'true';

    const progressBar = section.querySelector('[data-product-recommendations-progress]');
    const previousButton = section.querySelector('[data-product-recommendations-prev]');
    const nextButton = section.querySelector('[data-product-recommendations-next]');

    const getVisibleCells = () => {
      const cellWidth = flickity.cells[0]?.size.outerWidth || slider.clientWidth;
      return Math.max(1, Math.round(slider.clientWidth / cellWidth));
    };

    const getMaximumIndex = () => Math.max(0, flickity.cells.length - getVisibleCells());

    const moveByPage = (direction) => {
      const targetIndex = Math.max(
        0,
        Math.min(flickity.selectedIndex + direction * getVisibleCells(), getMaximumIndex())
      );

      flickity.select(targetIndex, false);
    };

    const updateProgress = (scrollProgress) => {
      if (!progressBar) return;

      const visibleCells = Math.min(getVisibleCells(), flickity.cells.length);
      const maximumIndex = getMaximumIndex();
      const normalizedProgress = typeof scrollProgress === 'number'
        ? Math.max(0, Math.min(1, scrollProgress))
        : maximumIndex
          ? Math.min(flickity.selectedIndex / maximumIndex, 1)
          : 0;
      const width = (
        (visibleCells + (flickity.cells.length - visibleCells) * normalizedProgress) /
        flickity.cells.length
      ) * 100;

      progressBar.style.width = `${Math.min(width, 100)}%`;
    };

    const updateNavigation = () => {
      const maximumIndex = getMaximumIndex();

      if (flickity.selectedIndex > maximumIndex) {
        flickity.select(maximumIndex, false, true);
        return;
      }

      previousButton.disabled = maximumIndex === 0 || flickity.selectedIndex <= 0;
      nextButton.disabled = maximumIndex === 0 || flickity.selectedIndex >= maximumIndex;
    };

    previousButton.addEventListener('click', () => moveByPage(-1));
    nextButton.addEventListener('click', () => moveByPage(1));
    flickity.on('scroll', updateProgress);
    flickity.on('select', updateNavigation);
    flickity.on('resize', () => {
      updateProgress();
      updateNavigation();
    });

    updateProgress();
    updateNavigation();
    document.fonts?.ready.then(() => flickity.resize());
  }

  function initAll(root = document) {
    if (root.matches?.(sectionSelector)) init(root);
    root.querySelectorAll?.(sectionSelector).forEach(init);
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      const section = mutation.target.closest?.(sectionSelector);
      if (section) init(section);
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) initAll(node);
      });
    });
  });

  initAll();
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
